export function hasTeamShieldColorsForLeague({ leagueId }: { leagueId: number }): boolean {
  return [
    LocalConstants.MLB,
    LocalConstants.NBA,
    LocalConstants.NFL,
    LocalConstants.NHL,
    LocalConstants.Eredivisie,
    LocalConstants.EFLChampionship,
    LocalConstants.EFLLeague1,
    LocalConstants.EflLeague2,
    LocalConstants.EPL,
    LocalConstants.Ligue1,
    LocalConstants.Bundesliga,
    LocalConstants.SerieA,
    LocalConstants.SPL,
    LocalConstants.LaLiga,
    LocalConstants.MLS,
    LocalConstants.Aleague,
    LocalConstants.NBL,
    LocalConstants.T20BBigBashMen,
    LocalConstants.T20BigBashWomen,
    LocalConstants.IPL,
    LocalConstants.TestNBA,
  ].includes(leagueId)
}

// ======
// Locals
// ======

const enum LocalConstants {
  MLB = 1000093616,
  NBA = 1000093652,
  NFL = 1000093656,
  NHL = 1000093657,
  Eredivisie = 1000094980,
  EFLChampionship = 1000094981,
  EFLLeague1 = 1000094982,
  EflLeague2 = 1000094987,
  EPL = 1000094985,
  Ligue1 = 1000094991,
  Bundesliga = 1000094994,
  SerieA = 1000095001,
  SPL = 1000095047,
  LaLiga = 1000095049,
  MLS = 1000095063,
  Aleague = 1000182606,
  NBL = 1000286559,
  T20BBigBashMen = 2000068063,
  T20BigBashWomen = 2000091469,
  IPL = 2000085727,
  TestNBA = 2000090528,
}

// cspell:words Aleague Bundesliga Eredivisie Liga Ligue Serie
